import React, { useEffect } from "react";
import LoadingSpinner from "components/loading/LoadingSpinner";
import { getRedirectUrl } from "helpers/redirectToProduct";

export const Redirection = () => {

  useEffect(() => {
    window.location.href = getRedirectUrl(sessionStorage.getItem("btpLink"));
  }, []);

  return (
    <>
      <LoadingSpinner/>
    </>
  );
}
